const baseFn = function () {};

const stopThreshold = 0.3;
const friction = 0.85;

// ES6 rewrite of the Drag Controller
export default class Drag {
  constructor () {
    this._onStart = baseFn;
    this._onMove = baseFn;
    this._onEnd = baseFn;

    this._reset();
  }

  // Public Methods
  // --------------------------------------------------
  // Add listeners
  onStart (fn) {
    if (typeof fn === 'function') {
      this._onStart = fn;
    }
  }

  onMove (fn) {
    if (typeof fn === 'function') {
      this._onMove = fn;
    }
  }

  onEnd (fn) {
    if (typeof fn === 'function') {
      this._onEnd = fn;
    }
  }

  onPinch (fn) {
    if (typeof fn === 'function') {
      this._onPinch = fn;
    }
  }

  // start on touch down, mouse down
  start (event, disableDefaultMove) {
    // reset momentum decelerating
    this._decelerating = false;
    event = event || window.event;

    this._disableDefaultMove = disableDefaultMove;
    this._setNewMousePosition(event.nativeEvent || event);

    if (event.touches) {
      if (event.touches.length === 2) {
        event.preventDefault && event.preventDefault();
        event.stopPropagation && event.stopPropagation();
      }
      document.ontouchmove = this._move.bind(this);
      document.ontouchend = this._stopAction.bind(this);
    }
    else {
      document.onmousemove = this._move.bind(this);
      document.onmouseup = this._stopAction.bind(this);
    }

    this._onStart(event);
  }

  // Implementation
  // --------------------------------------------------
  _move (nativeEvent) {
    nativeEvent = nativeEvent || window.event;

    if (this._disableDefaultMove) {
      // IE8 check
      nativeEvent.preventDefault && nativeEvent.preventDefault();
      nativeEvent.stopPropagation && nativeEvent.stopPropagation();
    }

    // multi finger touch event
    if (nativeEvent.touches && nativeEvent.touches.length !== 1) {
      // deal with pinch gesture
      if (nativeEvent.touches.length === 2) {
        this._onPinch(nativeEvent.touches);
      }

    }
    else { // move mouse or touch

      var clientX = nativeEvent.touches && nativeEvent.touches[0]
        ? nativeEvent.touches[0].clientX
        : nativeEvent.clientX;
      var clientY = nativeEvent.touches && nativeEvent.touches[0]
        ? nativeEvent.touches[0].clientY
        : nativeEvent.clientY;

      // find the diff of the movement
      var diffX = clientX - this._mouseX;
      var diffY = clientY - this._mouseY;

      this._setNewMousePosition(nativeEvent);

      // execute the on move event
      this._onMove(diffX, diffY, !nativeEvent.touches);
    }
  }

  _setNewMousePosition (nativeEvent) {
    if (nativeEvent.touches && nativeEvent.touches.length !== 1) {
      return;
    }

    var clientX = nativeEvent.touches && nativeEvent.touches[0] ? nativeEvent.touches[0].clientX : nativeEvent.clientX;
    var clientY = nativeEvent.touches && nativeEvent.touches[0] ? nativeEvent.touches[0].clientY : nativeEvent.clientY;

    this._setMouseCoordinates(clientX, clientY);
  }

  _setMouseCoordinates (x, y) {
    this._mouseX = x;
    this._mouseY = y;
    // var time = Date.now();
    // this._cleanupPoints();
    // this._trackingPoints.push({x, y, time});
  }

  _cleanupPoints () {
    var time = Date.now();
    while (this._trackingPoints.length > 0) {
      if (time - this._trackingPoints[0].time <= 100) {
        break;
      }
      this._trackingPoints.shift();
    }
  }

  _reset () {
    this._mouseX = 0;
    this._mouseY = 0;
    this._trackingPoints = [];
    this._disableDefaultMove = false;
  }

  _stopAction () {
    document.onmousemove = null;
    document.ontouchmove = null;
    document.onmouseup = null;
    document.ontouchend = null;

    // this._startDecelAnim();
    this._onEnd();
    this._reset();
  }

  _startDecelAnim () {
    this._cleanupPoints();
    // after cleanup might not have any left
    if (!this._trackingPoints.length) {
      return;
    }

    var firstPoint = this._trackingPoints[0];
    var lastPoint = this._trackingPoints[this._trackingPoints.length - 1];

    var xOffset = lastPoint.x - firstPoint.x;
    var yOffset = lastPoint.y - firstPoint.y;
    var timeOffset = lastPoint.time - firstPoint.time;

    var D = timeOffset / 15; // magic number

    this._decVelX = (xOffset / D) || 0; // prevent NaN
    this._decVelY = (yOffset / D) || 0;

    // var diff = checkBounds();
    if ((Math.abs(this._decVelX) > 1 || Math.abs(this._decVelY) > 1)) {
      this._decelerating = true;
      this._stepDecelAnim();
    }
  }

  _stepDecelAnim () {
    // when finished, cleanup an call the End
    if (!this._decelerating) {
      return;
    }

    this._decVelX *= friction;
    this._decVelY *= friction;

    if ((Math.abs(this._decVelX) > stopThreshold || Math.abs(this._decVelY) > stopThreshold)) {
      this._onMove(this._decVelX, this._decVelY, false);
      requestAnimFrame(this._stepDecelAnim.bind(this));
    }
    else {
      this._onEnd();
      this._decelerating = false;
    }
  }
}

/**
 * @see http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
 */
const requestAnimFrame = (function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 1000 / 60);
  };
})();



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/zoomer/drag.js